module.exports = __webpack_public_path__ + "media/images/img_consul-6d0a2b56e67174d1bcf7f9f7ed7bcbb2.png";